import { DeepPartial, ResultsGridConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_RESULTS: DeepPartial<ResultsGridConfig> = {
  components: {
    gridColumnsPicker: null,
    promoted: {
      wrapper: 'CdlPromoted'
    }
  },
  grid: {
    columns: 1,
    columnsPicker: []
  }
};

export const DESKTOP_RESULTS: DeepPartial<ResultsGridConfig> = {
  components: {
    gridColumnsPicker: 'CdlColumnsPicker'
  },
  grid: {
    columns: 4,
    columnsPicker: [4, 1]
  }
};
